import { useLanguage } from '@/contexts/LanguageContext';
import { demoAvatar } from '@/lib/demoAssets';
import { cn } from '@/lib/utils';

const EN_SRC = demoAvatar('En.png');
const FA_SRC = demoAvatar('Fa.png');

export function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  const renderFlag = (code: 'en' | 'fa', src: string, label: string) => {
    const active = language === code;
    return (
      <button
        type="button"
        onClick={() => setLanguage(code)}
        aria-label={`Switch to ${label}`}
        aria-pressed={active}
        className="flex flex-col items-center justify-end bg-transparent border-0 p-0 cursor-pointer outline-none focus-visible:ring-2 focus-visible:ring-primary rounded w-[60px] h-[76px]"
      >
        <img
          src={src}
          alt=""
          draggable={false}
          className={cn(
            'object-contain select-none transition-[width,height,opacity] duration-300 ease-out',
            active ? 'w-[60px] h-[60px] opacity-100' : 'w-[30px] h-[30px] opacity-50'
          )}
        />
        <span
          className={cn(
            'text-[11px] leading-none mt-1 font-bold transition-opacity duration-300',
            active ? 'opacity-100' : 'opacity-50'
          )}
        >
          {label}
        </span>
      </button>
    );
  };

  return (
    <div className="flex items-end gap-2" dir="ltr">
      {renderFlag('en', EN_SRC, 'English')}
      {renderFlag('fa', FA_SRC, 'فارسی')}
    </div>
  );
}
